export default class Random
{
    static integer(from: number = 0, to: number = 1000000): number {
        return Math.floor(Math.random() * to) + from;
    }
}
